import { render, staticRenderFns } from "./SMSView.vue?vue&type=template&id=006e5f28&scoped=true&"
import script from "./SMSView.vue?vue&type=script&lang=js&"
export * from "./SMSView.vue?vue&type=script&lang=js&"
import style0 from "./SMSView.vue?vue&type=style&index=0&id=006e5f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e5f28",
  null
  
)

export default component.exports